const Link = {
  baseStyle: {
    color: "gradient",
    fontFamily: "inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    textDecoration: "none",
  },
  variants: {
    flushed: {
      fontWeight: "500",
      fontSize: "12px",
      lineHeight: "14.5px",
      color: "black",
      _hover: {
        textDecoration: "none",
      },
      _focus: {
        boxShadow: "none",
      },
    },
  },
};

export default Link;
